import { getNumber } from './get';
import { postAnswer } from './post';

export const question = {
  getNumber,
  postAnswer,
};
